module.exports = __webpack_public_path__ + "img/s12.2253f4c5.png";